import gql from 'graphql-tag'

const query = gql`
query listTags($type: TagType!) {
	cashAssist {
	  listTags(type: $type) {
	    id
	    uid
	    name
	  }
	}
}`

export default query
